<template>
  <div class="member-arrange-item">
    <div class="main-line"></div>
    <div>
      <div>
        <span class="member-arrange-item_tag member-arrange-item_type">
          {{ (item.type || 3) | enum("PeriodsType") }}
        </span>
        <span class="member-arrange-item_tag member-arrange-item_classtype">
          {{ item.class_type == 1 ? "直播" : "面授" }}
        </span>
        <span>
          <!--         这边加个课次名称当arrange_type为1-->
          <template v-if="arrange_type == 1">
            {{ item.chapter_title ? item.chapter_title + " " : "" }}
          </template>
          {{ item.classify_name ? item.classify_name + " " : ""
          }}{{ item.grade_name ? item.grade_name + " " : ""
          }}{{ item.subject_name || item.sub_name }}
        </span>
      </div>
      <div class="member-arrange-item_left-middle">
        <span class="member-arrange-item_teacher">{{ item.teacher_name }}</span>
        <span class="subtitle-line">|</span>
        <span class="member-arrange-item_time">
          {{
            (item.start_time || item.start_play) | tsFormat("yyyy/MM/dd hh:mm")
          }}-{{ (item.end_time || item.end_play) | tsFormat("hh:mm") }}
        </span>
        <img
          v-if="times_status == 1"
          class="member-arrange-item_status-img"
          src="@/assets/images/periods/wait@2x.png"
        />
        <img
          v-else-if="times_status == 2"
          class="member-arrange-item_status-img"
          src="@/assets/images/periods/live@2x.png"
        />
        <img
          v-else-if="times_status == 3"
          class="member-arrange-item_status-img"
          src="@/assets/images/periods/end@2x.png"
        />
        <span
          class="member-arrange-item_status"
          :class="{ primary: times_status == 2 }"
        >
          {{ times_status | enum("ArrangeStatus") }}
        </span>
      </div>
      <div class="member-arrange-item_address" v-if="item.class_type == 2">
        <template v-if="item.room_name">
          上课教室：{{ item.room_name }}
        </template>
        <template v-else-if="item.province || item.province_name">
          上课地点：{{ item.province || item.province_name
          }}{{ item.city || item.city_name
          }}{{ item.distinct || item.district_name }}{{ item.address }}
        </template>
      </div>
      <template v-if="type == 1">
        <FileList :fileList="item.notes ? item.notes.slice(0, 3) : []" />
      </template>
      <template v-if="type != 1 && item.notes_status == 1">
        <FileList :fileList="[{ ...item, ware_filename: item.notes_name }]" />
      </template>
    </div>
    <div class="member-arrange-item_right" v-if="item.type == 1">
      <template v-if="times_status != 4">
        <template v-if="item.class_type == 1">
          <span
            v-if="times_status == 1 || times_status == 2"
            class="enter-live"
            @click="onPlay"
          >
            进入直播间
          </span>
          <span
            v-else-if="item.live_status == 3 || item.bjy_encode_status == 1"
            class="enter-live"
            @click="onPlay"
          >
            查看回放
          </span>
        </template>
      </template>
      <span v-else class="color-9">
        {{ item.leave_type == 1 ? "老师请假，课次取消" : "您已请假，课次取消" }}
      </span>
      <div class="btn-box">
        <span class="enter-live" @click="onCommunication(item)">沟通记录</span>
        <i v-if="!item.is_read" class="point"></i>
      </div>
      <div
        v-if="
          item.is_leave == 1 ||
          (item.attend_status == 1 && times_status == 3) ||
          (item.notes_status == 1 && type != 1)
        "
        class="operate"
        @mouseenter="debounceSetShow(true)"
        @mouseleave="debounceSetShow(false)"
      >
        <img src="../../../images/dian.png" />
        <transition name="fade">
          <div
            v-show="show"
            class="operate-btn-wrap"
            @mouseenter="debounceSetShow(true)"
            @mouseleave="debounceSetShow(false)"
          >
            <!--            <a-->
            <!--              v-if="item.notes_status == 1 && type != 1"-->
            <!--              class="popup-font"-->
            <!--              @click="onDownload(item)"-->
            <!--            >-->
            <!--              下载讲义-->
            <!--            </a>-->
            <a v-if="item.is_leave == 1" class="popup-font" @click="onLeave">
              请假
            </a>
            <template v-if="item.attend_status == 1 && times_status == 3">
              <a
                v-if="item.t_remark"
                class="popup-font"
                @click="onTeacherComment"
              >
                查看老师评价
              </a>
              <a v-if="times_status == 3" class="popup-font" @click="onComment">
                {{ item.s_remark ? "查看评价" : "评价" }}
              </a>
            </template>
          </div>
        </transition>
      </div>
    </div>
    <div
      class="member-arrange-item_right"
      :class="{ 'member-arrange-item_right-cancel': times_status == 4 }"
      v-else
    >
      <template v-if="times_status != 4">
        <template v-if="item.class_type == 1">
          <el-button
            v-if="times_status == 1 || times_status == 2"
            type="primary"
            @click="onPlay"
          >
            进入直播间
          </el-button>
          <el-button
            v-else-if="item.live_status == 3 || item.bjy_encode_status == 1"
            type="primary"
            @click="onPlay"
          >
            查看回放
          </el-button>
        </template>
        <!--        <a-->
        <!--          v-if="item.notes_status == 1 && type != 1"-->
        <!--          class="primary member-arrange-item_operate"-->
        <!--          @click="onDownload(item)"-->
        <!--        >-->
        <!--          下载讲义-->
        <!--        </a>-->

        <a
          v-if="item.is_leave == 1"
          class="primary member-arrange-item_operate"
          @click="onLeave"
        >
          请假
        </a>
        <template v-if="item.attend_status == 1 && times_status == 3">
          <a
            v-if="item.t_remark"
            class="primary member-arrange-item_operate"
            @click="onTeacherComment"
          >
            查看老师评价
          </a>
          <a
            v-if="times_status == 3"
            class="primary member-arrange-item_operate"
            @click="onComment"
          >
            {{ item.s_remark ? "查看评价" : "评价" }}
          </a>
        </template>
      </template>
      <span v-else class="color-9">
        {{ item.leave_type == 1 ? "老师请假，课次取消" : "您已请假，课次取消" }}
      </span>
    </div>
    <el-dialog
      class="member-arrange-item_comment"
      :class="{ readonly }"
      :title="title"
      :visible.sync="dialogVisible"
      v-model="remark"
      width="480px"
      append-to-body
    >
      <div class="member-arrange-item_content" v-if="readonly">
        {{ remark }}
      </div>
      <FormInput
        v-else
        type="textarea"
        :rows="8"
        placeholder="请输入对本次课的评价"
        :maxLength="100"
        v-model="remark"
        :readonly="readonly"
      ></FormInput>
      <template v-slot:footer>
        <el-button v-if="!readonly" @click="dialogVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="onSubmitComment">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import FileList from "@/modules/stu/components/FileList";
export default {
  name: "MemberArrangeItem",
  components: {
    FileList,
  },
  props: {
    type: {
      type: Number,
    },
    item: {
      type: Object,
      default: () => {},
    },
    arrange_type: {
      default: "",
    },
  },
  data() {
    return {
      dialogVisible: false,
      remark: "",
      readonly: false,
      title: "",
      fileList: [],
      show: false,
      debounceSetShow: this.$pub.debounce(this.setShow, 100),
    };
  },
  computed: {
    times_status() {
      if (this.item.times_status) {
        return this.item.times_status;
      }
      let ts = parseInt(new Date().getTime() / 1000);
      if (ts < this.item.start_play) {
        return 1;
      } else if (ts >= this.item.start_play && ts <= this.item.end_play) {
        return 2;
      }
      return 3;
    },
  },
  methods: {
    setShow(val) {
      this.show = val;
    },
    async getLiveRoom(type, arrange_id) {
      let data = await this.$http.get(
        "/api/app/getPcRoomCode/course_id=0/chapter_id=0",
        { type, arrange_id },
      );
      return data.chapterInfo;
    },
    async onPlay() {
      let type = this.type == 1 ? 4 : 3;
      let arrange_id = this.item.id || this.item.arrange_id;
      let { href } = this.$router.resolve({
        name: "Live",
        query: {
          course_id: 0,
          period_id: 0,
          type,
          course_type: 2,
          arrange_id,
        },
      });
      if (this.$store.state.commonSetting.client_download_on == 0) {
        document.location = href;
      } else if (this.$store.state.commonSetting.client_download_on == 1) {
        let liveData = await this.getLiveRoom(type, arrange_id);
        if (liveData.client_url) {
          const { href } = this.$router.resolve({
            name: "DownloadClient",
            query: {
              url: liveData.client_url,
            },
          });
          document.location = href;
        } else {
          document.location = href;
        }
      } else if (this.$store.state.commonSetting.client_download_on == 2) {
        this.$courseExtension.openLiveSelect({
          webHandler: () => {
            document.location = href;
          },
          clientHandler: async () => {
            let liveData = await this.getLiveRoom(type, arrange_id);
            if (liveData.client_url) {
              this.$services.LiveService.openClient(liveData.client_url);
            } else {
              document.location = href;
            }
          },
        });
      }
    },
    async onLeave() {
      await this.$promiseConfirm("请假后不能取消，确认请假吗？", {
        customClass: "confirm-simple",
      });
      await this.$http.post("/api/app/arrange/leave", {
        type: this.type,
        student_times_id: this.item.student_times_id,
      });
      this.$emit("leave");
      this.$success("请假成功");
    },
    onComment() {
      if (this.item.s_remark) {
        this.readonly = true;
        this.remark = this.item.s_remark;
        this.title = "查看评价";
      } else {
        this.readonly = false;
        this.remark = "";
        this.title = "课次评价";
      }
      this.dialogVisible = true;
    },
    async onSubmitComment() {
      if (this.readonly) {
        this.dialogVisible = false;
        return;
      }
      if (!this.remark) {
        return this.$info("请输入评价内容");
      }
      await this.$http.post("/api/app/arrange/evaluate", {
        type: this.type,
        student_times_id: this.item.student_times_id,
        s_remark: this.remark,
      });
      this.item.s_remark = this.remark;
      this.dialogVisible = false;
      this.$success("评价成功");
    },
    onTeacherComment() {
      this.title = "查看老师评价";
      this.readonly = true;
      this.remark = this.item.t_remark;
      this.dialogVisible = true;
    },
    onCommunication(item) {
      this.$router.push({
        name: "PeriodsMemberOtoCommunication",
        query: {
          id: item.id,
        },
      });
    },
    onDownload(item) {
      window.open(item.notes_url);
    },
  },
};
</script>
<style lang="scss" scoped>
.member-arrange-item {
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  padding: 13px 24px 13px 19px;
  margin-bottom: 20px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  position: relative;
  .main-line {
    position: absolute;
    height: 100%;
    width: 4px;
    left: 0;
    top: 0;
    background: #bb1c20;
  }
}
.member-arrange-item_right {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  /deep/ {
    .el-button {
      padding: 7px 17px;
      border-radius: 15px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .operate {
    width: 34px;
    height: 34px;
    background: #ffffff;
    border: 1px solid #bfbfbf;
    border-radius: 19px;
    flex-shrink: 0;
    margin-left: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    img {
      width: 16px;
      height: 3px;
    }
    .operate-btn-wrap {
      width: 128px;
      box-sizing: border-box;
      position: absolute;
      background: #ffffff;
      border-radius: 4px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      right: 0;
      top: 40px;
      padding: 12px 12px 0;
      display: flex;
      flex-direction: column;
      z-index: 99;
      .popup-font {
        font-size: 14px;
        color: #333333;
        text-align: left;
        cursor: pointer;
        margin-bottom: 10px;
        &:hover {
          color: $primary-color;
        }
      }
    }
  }
}
.member-arrange-item_tag {
  display: inline-block;
  border-radius: 4px;
  padding: 3px 6px;
  box-sizing: border-box;
  font-size: 12px;
}
.member-arrange-item_type {
  background: rgba($primary-color, 0.1);
  color: $primary-color;
  margin-right: 6px;
}
.member-arrange-item_classtype {
  background: rgba(#ffba16, 0.15);
  color: #eb8700;
  margin-right: 9px;
}
.member-arrange-item_left-middle {
  margin: 8px 0 7px 0;
  .subtitle-line {
    margin: 0 8px;
    color: #d8d8d8;
  }
}
.member-arrange-item_teacher {
  color: #999999;
}
.member-arrange-item_time {
  color: #999999;
  margin-right: 10px;
}
.member-arrange-item_address {
  color: #666;
  margin-top: 7px;
}
.member-arrange-item_status-img {
  width: 14px;
  height: 15px;
  margin-right: 6px;
  vertical-align: -2px;
}
.member-arrange-item_status {
  color: #999;
}
.member-arrange-item_operate {
  cursor: pointer;
  //margin-bottom: 11px;
  margin-bottom: 0;
  margin-left: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.no-color {
  color: #333333 !important;
  &:hover {
    color: $primary-color;
  }
}
.member-arrange-item_right-cancel {
  width: 130px;
}
.member-arrange-item_comment {
  /deep/ {
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__title {
      font-size: 16px;
    }
    .el-dialog__header {
      font-size: 16px;
      font-family: PingFang SC Medium, PingFang SC Medium-Medium;
      font-weight: 500;
      color: #333333;
      padding: 24px;
    }
    .el-dialog__body {
      padding: 0 24px 24px 24px;
    }
    .el-dialog__footer {
      padding: 0 24px 24px 24px;
    }
  }
  .el-button {
    padding: 10px 28px;
    border-radius: 5px;
  }
  .member-arrange-item_content {
    font-size: 14px;
    color: #666666;
    line-height: 22px;
  }
  &.readonly {
    /deep/ {
      .el-dialog__header {
        padding: 16px 24px;
      }
    }
  }
}
.no-bottom {
  margin-bottom: 0;
  flex-shrink: 0;
}
.btn-box {
  display: inline-block;
  position: relative;
  .point {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: #ff2424;
    position: absolute;
    right: 3px;
    top: -9px;
  }
}
.enter-live {
  font-size: 14px;
  border: 1px solid #bfbfbf;
  cursor: pointer;
  border-radius: 19px;
  padding: 7px 20px;
  color: #333333;
  margin-left: 9px;
  &:hover {
    border-color: #bb1c20;
    color: #bb1c20;
  }
}
</style>
